import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.7 3.286a1 1 0 0 1 .013 1.415l-6.875 7a1 1 0 0 1-1.426 0L2.287 8.519a1 1 0 0 1 1.426-1.402l2.412 2.456 6.162-6.274a1 1 0 0 1 1.414-.013",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }